import React from 'react';
export function Guarantee() {
  return <section className="py-12 sm:py-20" data-id="element-158">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-159">
        <div className="flex flex-col items-center gap-9 rounded-2xl border border-border bg-[#0a0900] p-8 text-center sm:flex-row sm:items-start sm:p-12 sm:text-left" data-id="element-160">
          <div className="shrink-0 text-[56px]" data-id="element-161">🛡️</div>
          <div data-id="element-162">
            <h3 className="mb-3 font-serif text-[24px] font-bold text-white" data-id="element-163">
              7 Días de Garantía Total
            </h3>
            <p className="text-[14px] leading-[1.7] text-text" data-id="element-164">
              Abrís los tomos, revisás los bonos, usás las planillas y el
              directorio de proveedores.
              <br data-id="element-165" />
              <br data-id="element-166" />
              Si en 7 días decidís que no es lo que esperabas:{' '}
              <strong className="font-bold text-white" data-id="element-167">
                sin preguntas, sin formularios, sin drama
              </strong>
              . Te devolvemos el 100% de lo que pagaste.
              <br data-id="element-168" />
              <br data-id="element-169" />
              El riesgo es cero. La plata que perdés esperando otro mes más para
              arrancar, esa no te la devuelve nadie.
            </p>
          </div>
        </div>
      </div>
    </section>;
}